define([
	'require',
	'jquery',
	'Handlebars',
	'handlebars-data-helpers'
], function(require, $, Handlebars){
	
	/*
		VFDP Base class for Handlebars widgets and modules - all methods of the handlebarsCore object can be overwritten as needed in individual widget module definitions
	*/

	var DEBUG = false;

	var handlebarsCore = {
		
		defaults : {
			action : 'append', // default jQuery method for adding rendered data to target element
			data : ''
		},
		//
		//
		//
		init : function () {

			if ( DEBUG ) console.log('Initializing ' + this.pluginID);

			var self = this;

			self.config = $.extend( true, {}, self.defaults, self.options, self.metadata );
			
			if ( DEBUG ) console.log('init, configuration : ', self.config);

			$.when(
				self.loadAndCompileTemplate(), 
				self.fetchData()
			).done(function(template, data){
				self.render(data);
			});
			
			return self;
		},

		//
		//	load and compile template from supplied template string in options
		//	this will be augmented to check for precompiled version of template 
		//	in template namespace and assign it to object property if present
		//	if no precompiled template is matched, it will then revert to require loading
		//
		loadAndCompileTemplate : function () {

			if ( DEBUG ) console.log('core template loader loadAndCompileTemplate');

			var self = this,
				$templateDeferred = $.Deferred();
		
			require([ self.config.template ], function(templateString){
				if ( DEBUG ) console.log('self.config.template, template  : ',self.config.template, templateString);
				// assign compiled template to object property
				self.compiledTemplate = Handlebars.compile(templateString);
				// resolve the deferred object
				$templateDeferred.resolve();
			
			});

			return $templateDeferred.promise();
		
		},

		//
		//	generic data fetch method
		//
		fetchData : function () {

			if ( DEBUG ) console.log('fetchData');

			var self = this,
				$dataFetchDeferred = $.Deferred();

			$.ajax({
				url: self.url,
				data: {
					storeId: self.storeId,
					partNumber: self.partNumber
				}
			}).done(function(response){
				
				$dataFetchDeferred.resolve(response);

			}).fail(function(){
				
				if ( DEBUG ) {
					console.warn('AJAX Failed : ');
					$(arguments).each(function(){
						console.warn(this);
					});
				}
				
			});

			return $dataFetchDeferred.promise();

		},

		//
		//	generic render method using supplied action
		//
		render : function (data) {

			if ( DEBUG ) console.log('core render, data : ', data );
			
			var self = this;

			self.$element[self.config.action]( self.compiledTemplate(data) );

		}
	};

	return handlebarsCore;

});